/* PainGone · October 2026 update layer: announcement rotator + mobile sticky Buy Now bar */
(function () {
  'use strict';
  var reduced = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Announcement rotator */
  function initRotators() {
    document.querySelectorAll('[data-pg4-rotator]').forEach(function (root) {
      var msgs = root.querySelectorAll('.pg4-announcement-msg');
      if (msgs.length < 2 || reduced || root.dataset.pg4Ready) return;
      root.dataset.pg4Ready = '1';
      var i = 0, paused = false, ms = parseInt(root.dataset.interval, 10) || 4000;
      root.addEventListener('mouseenter', function () { paused = true; });
      root.addEventListener('mouseleave', function () { paused = false; });
      root.addEventListener('focusin', function () { paused = true; });
      root.addEventListener('focusout', function () { paused = false; });
      setInterval(function () {
        if (paused || document.hidden) return;
        msgs[i].classList.remove('pg4-is-active'); msgs[i].setAttribute('aria-hidden', 'true');
        i = (i + 1) % msgs.length;
        msgs[i].classList.add('pg4-is-active'); msgs[i].removeAttribute('aria-hidden');
      }, ms);
    });
  }

  /* Sticky Buy Now: visible on load; hidden whenever any buy button / offer card is on screen */
  function initSticky() {
    var bar = document.querySelector('[data-pg4-sticky]');
    if (!bar || !('IntersectionObserver' in window)) return;
    var targets = document.querySelectorAll('[data-pg4-buy-target], .pg4-bottom-offer-card, .pg4-buy-strip');
    var onScreen = new Set();
    var ready = false;
    function update() {
      var modalOpen = !!document.querySelector('.pg4-modal.pg4-open');
      var show = ready && onScreen.size === 0 && !modalOpen;
      bar.classList.toggle('pg4-sticky-visible', show);
      if (show && !bar.dataset.pg4Seen) { bar.dataset.pg4Seen = '1'; if (window.pg4Track) window.pg4Track('pg4_sticky_shown', {}); }
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      var btn = bar.querySelector('button'); if (btn) btn.tabIndex = show ? 0 : -1;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) onScreen.add(e.target); else onScreen.delete(e.target); });
      update();
    }, { threshold: 0.15 });
    targets.forEach(function (t) { io.observe(t); });
    setTimeout(function () { ready = true; update(); }, reduced ? 0 : 350);
    document.addEventListener('click', function () { setTimeout(update, 50); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setTimeout(update, 50); });
  }

  function init() { initRotators(); initSticky(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

/* ---------------------------------------------------------------------------
   PainGone analytics bridge
   The theme never sends data to GA4 itself. It ANNOUNCES events two ways at once
   so either tracking setup can pick them up (and nothing is double-counted):
     1. window.dataLayer.push({event: ...})        → Google Tag Manager in the theme
     2. Shopify.analytics.publish(name, data)      → Shopify Customer Events / custom pixel
   Events:
     pg4_page_context        every page: page_kind (drtv|product|condition|home|…), template, product info
     pg4_cta_click           any button/link with data-pg4-cta (hero, sticky, strip-1, strip-2, final, pdp, package, condition, card-*, home-hero)
     pg4_add_to_cart_click   the same CTA when it submits an add-to-cart form (adds variant_id + quantity)
     pg4_sticky_shown        first time the mobile sticky bar appears
   --------------------------------------------------------------------------- */
(function () {
  'use strict';
  var ctx = {};
  try { var el = document.getElementById('pg4-analytics-context'); if (el) ctx = JSON.parse(el.textContent || '{}'); } catch (e) {}

  function track(name, data) {
    var payload = {};
    for (var k in ctx) payload[k] = ctx[k];
    for (var j in (data || {})) payload[j] = data[j];
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: name, pg4: payload }); } catch (e) {}
    try { if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish(name, payload); } catch (e) {}
  }
  window.pg4Track = track;

  function ready(fn) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); }
  ready(function () { track('pg4_page_context', {}); });
  // Back/forward cache: let forms be tracked again when the shopper returns
  window.addEventListener('pageshow', function () { document.querySelectorAll('form[data-pg4-tracked]').forEach(function (f) { delete f.dataset.pg4Tracked; }); });

  // Link-style CTAs (cards, condition button, home hero)
  document.addEventListener('click', function (e) {
    var el = e.target.closest && e.target.closest('[data-pg4-cta]');
    if (!el || el.type === 'submit') return;
    track('pg4_cta_click', { cta: el.getAttribute('data-pg4-cta'), href: el.getAttribute('href') || '' });
  }, true);

  // Add-to-cart CTAs: announce, then continue the normal form post after a short beat
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.dataset.pg4Tracked === '1') return;
    var btn = (e.submitter && e.submitter.hasAttribute('data-pg4-cta')) ? e.submitter : form.querySelector('[data-pg4-cta]');
    if (!btn) return;
    var idInput = form.querySelector('[name="id"]'), qtyInput = form.querySelector('[name="quantity"]');
    var data = { cta: btn.getAttribute('data-pg4-cta'), variant_id: idInput ? idInput.value : null, quantity: qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1 };
    track('pg4_cta_click', data);
    track('pg4_add_to_cart_click', data);
    e.preventDefault();
    form.dataset.pg4Tracked = '1';
    setTimeout(function () { HTMLFormElement.prototype.submit.call(form); }, 150);
  });
})();

/* ---------------------------------------------------------------------------
   PainGone · TryBee free trial on TV (DRTV) pages
   Runs only on the TV pages and views switched on under Theme settings > PainGone TV pages >
   Free trial (TryBee), and only for a product that's in TryBee's trial list.
   Every other page and product keeps normal add-to-cart buttons.
   --------------------------------------------------------------------------- */
(function () {
  'use strict';
  var TRIAL_TEMPLATES = ['drtv-fllow', 'drtv-aegis', 'drtv-easy', 'drtv-plus', 'drtv-ellune'];   // all TV pages

  function onTrialPage() {
    if (typeof window.pg4TrialOn === 'boolean') return window.pg4TrialOn;
    try {
      var ctx = JSON.parse(document.getElementById('pg4-analytics-context').textContent);
      return TRIAL_TEMPLATES.indexOf(ctx.template_suffix) !== -1;
    } catch (e) { return false; }
  }
  function cfg() { var c = window.trybeforeMetafield; return c && c.plan_id ? c : null; }
  function isTrialProduct(productId) {
    var c = cfg();
    if (!c || !productId) return false;
    var gid = 'gid://shopify/Product/' + productId;
    return (c.selected_products || []).some(function (x) { return x.id === gid; });
  }

  window.addEventListener('submit', async function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
    var btn = (e.submitter && e.submitter.hasAttribute('data-pg4-cta')) ? e.submitter : form.querySelector('[data-pg4-cta]');
    if (!btn || !onTrialPage()) return;
    var idInput = form.querySelector('[name="id"]');
    var pidInput = form.querySelector('[name="product-id"]');
    var productId = pidInput && pidInput.value;
    if (!idInput || !isTrialProduct(productId)) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    var c = cfg();
    var variantId = parseInt(idInput.value, 10);
    var qtyInput = form.querySelector('[name="quantity"]');
    var qty = parseInt(qtyInput && qtyInput.value, 10) || 1;
    var planId = parseInt(String(c.plan_id).split('/').pop(), 10);
    var original = btn.innerHTML;

    if (window.pg4Track) window.pg4Track('pg4_add_to_cart_click', { cta: btn.getAttribute('data-pg4-cta'), variant_id: variantId, quantity: qty, trial: true });

    // Respect TryBee's "max products in a trial" rule if its helper is loaded
    try {
      if (window.TryBeeShared && typeof TryBeeShared.validateMaxProductsLimit === 'function') {
        var v = await TryBeeShared.validateMaxProductsLimit(c, qty, productId);
        if (v && !v.isValid && !v.isProductInCart) {
          alert('The free trial allows up to ' + v.maxProducts + ' item' + (v.maxProducts === 1 ? '' : 's') + ' per order. Please lower the quantity.');
          return;
        }
      }
    } catch (err) {}

    btn.disabled = true;
    btn.textContent = 'Adding…';
    try {
      var items = [{ id: variantId, quantity: qty, selling_plan: planId, properties: { _trybee: true } }];
      if (c.service_fee_enabled && c.service_fee_variant_id) {
        var feeInCart = false;
        try { feeInCart = await TryBeeShared.isServiceFeeInCart(c.service_fee_variant_id); } catch (err) {}
        if (!feeInCart) items.push({ id: parseInt(c.service_fee_variant_id, 10), quantity: 1, properties: { _trybee_fee: true } });
      }
      var res = await fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items, attributes: { _trybee: true } })
      }).then(function (r) { return r.json(); });
      if (res && res.status && res.status !== 200) throw new Error(res.description || 'Could not add to cart');
      await fetch('/cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { _trybee: true } })
      });
      window.location.href = '/cart';
    } catch (err) {
      btn.disabled = false;
      btn.innerHTML = original;
      alert('Sorry, something went wrong adding your free trial to the cart. Please try again.');
    }
  }, true);
})();